import { Box, List, ListItemButton, ListItemText, Popover, Typography } from "@mui/material";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import { format } from "date-fns";

import type { StoryMapSummary } from "../../types/storyMap";
import { StatusChip } from "./StoryRow";
import { storyThumbnailUrl } from "./storyRows";

interface StoryStackPopoverProps {
  anchorEl: HTMLElement | null;
  title: string;
  stories: StoryMapSummary[];
  onClose: () => void;
  onOpenStory: (story: StoryMapSummary) => void;
}

/** A stacked marker's stories, to pick one from. */
export default function StoryStackPopover({ anchorEl, title, stories, onClose, onOpenStory }: StoryStackPopoverProps) {
  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      transformOrigin={{ vertical: "top", horizontal: "center" }}
      slotProps={{ paper: { sx: { width: 320, maxHeight: 360 } } }}
    >
      <Typography variant="subtitle2" sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
        {title}
      </Typography>
      <List dense disablePadding sx={{ pb: 1 }}>
        {stories.map((story) => {
          const thumb = storyThumbnailUrl(story, 112, 70);
          return (
            <ListItemButton
              key={story.id}
              onClick={() => {
                onClose();
                onOpenStory(story);
              }}
              sx={{ gap: 1.5 }}
            >
              <Box
                sx={{
                  width: 56,
                  height: 35,
                  flex: "0 0 auto",
                  borderRadius: 1,
                  backgroundColor: "#e2e8f0",
                  backgroundImage: thumb ? `url("${thumb}")` : undefined,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#94a3b8",
                }}
              >
                {!thumb && <MapOutlinedIcon fontSize="small" />}
              </Box>
              <ListItemText
                primary={story.title}
                secondary={
                  <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
                    <StatusChip story={story} />
                    {story.updated_at ? format(new Date(story.updated_at), "MMM d, yyyy") : null}
                  </Box>
                }
                primaryTypographyProps={{ noWrap: true, fontWeight: 600 }}
                secondaryTypographyProps={{ component: "span" }}
              />
            </ListItemButton>
          );
        })}
      </List>
    </Popover>
  );
}
